export default "__VITE_ASSET__5VsHAUAn__"